import React, { useState, useEffect, use } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setQuestionForm,
  setState,
  updateQuestion,
  updateThematicQuestion,
  addManualQuestion,
  getQuizQuestions,
  getThematicQuizQuestions,
  fetchThemes,
  fetchGroups,
  fetchSubjects,
  fetchSubjectBasedClassesData,
  updateSkippedQuestion,
  updateSkippedThematicQuestion,
} from "./redux/schoolQuizSlice";
// import {
//   fetchClassesThunk,
//   fetchSubjectsByClassThunk,
// } from "../../components/chapter/redux/chapterThunk";
import API_BASE_URL, { SCHOOL_QUIZ_API_BASE_URL } from "../config";
import ThemeSelector from "../../School-Quiz-Mgt-admin/pages/ThemeSelector";
// export default function EditOrViewLawCollegeQuiz({ quizType }) {
//   const dispatch = useDispatch();
//   const { questionForm = {}, mode } = useSelector((s) => s.schoolQuiz || {});
//   const [saving, setSaving] = useState(false);

//   //for themse and groups
//   const {
//     theme_id,
//     group_id,
//     subject_id,
//     class_id,
//     themes,
//     themesStatus,
//     themesError,
//     groups,
//     groupsStatus,
//     groupsError,
//   } = useSelector((state) => state.schoolQuiz);
//   const { updateQuizForm, selectedSubThemes } = useSelector(
//     (state) => state.quizManagement
//   );
//   const { classes = [], subjects = [] } = useSelector(
//     (state) => state.chapter || {}
//   );

//   // Load both themes and groups on mount
//   useEffect(() => {
//     if (themesStatus === "idle") dispatch(fetchThemes());
//     if (groupsStatus === "idle") dispatch(fetchGroups());
//   }, [dispatch, themesStatus, groupsStatus]);

//   // user id parsing
//   const userStr = localStorage.getItem("user");
//   const userId = userStr ? JSON.parse(userStr)?.id || "" : "";

//   // helper to update a single field inside questionForm in redux
//   const updateField = (key, value) => {
//     dispatch(setQuestionForm({ key, value }));
//   };

//   // convenience values (fallbacks)
//   const qId = questionForm.questionId ?? questionForm.id ?? "";
//   const questionText = questionForm.question ?? questionForm.content ?? "";
//   const option_a = questionForm.option_a ?? questionForm.options?.A ?? "";
//   const option_b = questionForm.option_b ?? questionForm.options?.B ?? "";
//   const option_c = questionForm.option_c ?? questionForm.options?.C ?? "";
//   const option_d = questionForm.option_d ?? questionForm.options?.D ?? "";
//   const correct_option = questionForm.correct_option ?? "";
//   const difficulty_level =
//     questionForm.difficulty_level ?? questionForm.level ?? "";
//   const selectedTheme = selectedSubThemes
//     ? selectedSubThemes
//     : [updateQuizForm.themeId];
//   // questionForm.theme_id ?? questionForm.theme ?? questionForm.themeId ?? "";

//   const selectedGroup =
//     questionForm.group_id ?? questionForm.group ?? questionForm.groupId ?? "";
//   const selectedClass = questionForm.class_id ?? "";
//   const selectedSubject = questionForm.subject_id ?? "";
//   const hasTheme = selectedTheme !== "";
//   const hasGroup = selectedGroup !== "";
//   const hasThemeAndGroup = hasTheme && hasGroup;

//   const isView = mode === "view";

//   const handleChange = (key, value) => {
//     dispatch({
//       type: "schoolQuiz/setState",
//       payload: { key, value },
//     });
//   };

//   // Fetch classes once on mount (unconditional)
//   useEffect(() => {
//     dispatch(fetchClassesThunk());
//   }, [dispatch]);

//   // Fetch subjects whenever the selectedClass inside questionForm changes
//   useEffect(() => {
//     if (!selectedClass) return;
//     dispatch(fetchSubjectsByClassThunk(String(selectedClass)));
//   }, [dispatch, selectedClass]);

//   const handleSave = async () => {
//     // basic validation
//     if (!questionText.trim()) {
//       alert("Question text is required.");
//       return;
//     }
//     if (!option_a || !option_b || !option_c || !option_d) {
//       alert("All options are required.");
//       return;
//     }
//     if (!correct_option) {
//       alert("Correct option is required.");
//       return;
//     }
//     if (!difficulty_level) {
//       alert("Difficulty is required.");
//       return;
//     }

//     setSaving(true);
//     const payload = {
//       id: qId,
//       content: questionText,
//       level: difficulty_level,
//       correct_option,
//       updated_by: userId || null,
//       options: { A: option_a, B: option_b, C: option_c, D: option_d },
//       theme_id: selectedTheme,
//       group_id: selectedGroup,
//     };
//     console.log("payload", payload);
//     console.log("theme id", questionForm.theme_id);
//     console.log("selectedSubThemes", selectedSubThemes);
//     try {
//       if (qId) {
//         // pack payload as you already do (include class_id/subject_id or theme_id/group_id)
//         const payload = {
//           id: qId,
//           content: questionText,
//           level: difficulty_level,
//           correct_option,
//           updated_by: userId || null,
//           options: { A: option_a, B: option_b, C: option_c, D: option_d },
//         };

//         if (hasThemeAndGroup) {
//           payload.theme_id = selectedTheme;
//           payload.group_id = selectedGroup;
//           // use thematic endpoint
//           await dispatch(updateThematicQuestion(payload)).unwrap();
//         } else {
//           payload.class_id = selectedClass;
//           payload.subject_id = selectedSubject;
//           await dispatch(updateQuestion(payload)).unwrap();
//         }

//         // refresh lists
//         if (hasThemeAndGroup) {
//           window.location.reload();
//           dispatch(getThematicQuizQuestions({ body: {} }));
//         } else {
//           dispatch(getQuizQuestions({ body: {} }));
//         }

//         alert("Question updated successfully.");
//       }

//       // close modal
//       dispatch(setState({ key: "openPopUp", value: false }));
//       dispatch(setState({ key: "mode", value: "" }));
//     } catch (err) {
//       console.error("Save error:", err);
//       const errMsg =
//         (err && err.message) || (err && err?.response?.data) || "Save failed.";
//       alert(errMsg);
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleClose = () => {
//     dispatch(setState({ key: "openPopUp", value: false }));
//     dispatch(setState({ key: "mode", value: "" }));
//   };

//   // const selectedSubThemes = questionForm.theme_id;
//   return (
//     <div>
//       <div className="mb-4">
//         <label className="form-label font-medium">Question</label>
//         <textarea
//           className="form-control"
//           value={questionText}
//           onChange={(e) => updateField("question", e.target.value)}
//           readOnly={isView}
//           rows={3}
//         />
//       </div>
//       <div className="row">
//         <div className="col-md-6 mb-3">
//           <label className="form-label">Option A</label>
//           <input
//             className="form-control"
//             value={option_a}
//             onChange={(e) => updateField("option_a", e.target.value)}
//             readOnly={isView}
//           />
//         </div>

//         <div className="col-md-6 mb-3">
//           <label className="form-label">Option B</label>
//           <input
//             className="form-control"
//             value={option_b}
//             onChange={(e) => updateField("option_b", e.target.value)}
//             readOnly={isView}
//           />
//         </div>

//         <div className="col-md-6 mb-3">
//           <label className="form-label">Option C</label>
//           <input
//             className="form-control"
//             value={option_c}
//             onChange={(e) => updateField("option_c", e.target.value)}
//             readOnly={isView}
//           />
//         </div>

//         <div className="col-md-6 mb-3">
//           <label className="form-label">Option D</label>
//           <input
//             className="form-control"
//             value={option_d}
//             onChange={(e) => updateField("option_d", e.target.value)}
//             readOnly={isView}
//           />
//         </div>

//         <div className="col-md-6 mb-3">
//           <label className="form-label">Correct Option</label>
//           <select
//             className="form-control"
//             value={correct_option}
//             onChange={(e) => updateField("correct_option", e.target.value)}
//             disabled={isView}
//           >
//             <option value="">-- Select --</option>
//             <option value="A">A</option>
//             <option value="B">B</option>
//             <option value="C">C</option>
//             <option value="D">D</option>
//           </select>
//         </div>

//         <div className="col-md-6 mb-3">
//           <label className="form-label">Difficulty</label>
//           <select
//             className="form-control"
//             value={difficulty_level}
//             onChange={(e) => updateField("difficulty_level", e.target.value)}
//             disabled={isView}
//           >
//             <option value="">-- Select --</option>
//             <option value="basic">Basic</option>
//             <option value="advanced">Advanced</option>
//             <option value="ultra">Ultra</option>
//             <option value="docmaster">Docmaster</option>
//           </select>
//         </div>
//       </div>
//       {/* {quizType === "thematic" && ( */}
//       {quizType === "thematic" && (
//         <ThemeSelector
//           themes={themes}
//           themeData={questionForm.themeData}
//           isView={isView}
//         />
//       )}{" "}
//       {/* )} */}
//       {/* CONDITIONAL: show Theme+Group if question object contains them, otherwise show Class+Subject */}
//       <div className="mt-3">
//         {hasThemeAndGroup ? (
//           <>
//             {/* <div className="mb-3">
//               <label className="form-label">Theme</label>
//               {themesStatus === "loading" ? (
//                 <p>Loading themes...</p>
//               ) : themesError ? (
//                 <p style={{ color: "red" }}>{themesError}</p>
//               ) : (
//                 <select
//                   className="form-control"
//                   name="theme_id"
//                   value={selectedTheme}
//                   onChange={(e) => handleChange("theme_id", e.target.value)}
//                   disabled={isView}
//                 >
//                   <option value="">-- Select Theme --</option>
//                   {themes.map((t) => (
//                     <option key={t.theme_id} value={t.theme_id}>
//                       {t.name}
//                     </option>
//                   ))}
//                 </select>
//               )}
//             </div> */}

//             <div className="mb-3">
//               <label className="form-label">Group</label>
//               {groupsStatus === "loading" ? (
//                 <p>Loading groups...</p>
//               ) : groupsError ? (
//                 <p style={{ color: "red" }}>{groupsError}</p>
//               ) : (
//                 <select
//                   className="form-control"
//                   name="group_id"
//                   value={selectedGroup || ""}
//                   onChange={(e) => handleChange("group_id", e.target.value)}
//                   disabled={isView}
//                 >
//                   <option value="">-- Select Group --</option>
//                   {groups.map((g) => (
//                     <option key={g.group_id} value={g.group_id}>
//                       {g.group_name}
//                     </option>
//                   ))}
//                 </select>
//               )}
//             </div>
//           </>
//         ) : (
//           <>
//             {/* Class */}
//             <div className="mb-3">
//               <label className="form-label">Class</label>

//               <select
//                 className="form-control"
//                 value={selectedClass || ""}
//                 onChange={(e) => {
//                   const newClassId = e.target.value; // always primitive (string)
//                   console.log(
//                     "Selected class id:",
//                     newClassId,
//                     typeof newClassId
//                   );
//                   updateField("class_id", newClassId);
//                   updateField("subject_id", "");
//                   dispatch(fetchSubjectsByClassThunk({ classId: newClassId }));
//                 }}
//                 disabled={isView}
//               >
//                 <option value="">-- Select Class --</option>
//                 {classes.map((c) => {
//                   const id = c.class_id ?? c.id ?? c._id ?? "";
//                   const label = c.class_name ?? c.name ?? `Class ${id}`;
//                   return (
//                     <option key={id} value={id}>
//                       {label}
//                     </option>
//                   );
//                 })}
//               </select>
//             </div>

//             {/* Subject */}
//             <div className="mb-3">
//               <label className="form-label">Subject</label>

//               <select
//                 className="form-control"
//                 value={selectedSubject || ""}
//                 onChange={(e) => {
//                   const newSubjectId = e.target.value;
//                   updateField("subject_id", newSubjectId);
//                   console.log("Selected subject id:", newSubjectId);
//                 }}
//                 disabled={isView || !selectedClass}
//               >
//                 <option value="">-- Select Subject --</option>
//                 {subjects.map((s) => {
//                   const id = String(s.subject_id ?? s.id ?? s._id ?? "");
//                   const label = s.subject_name ?? s.name ?? `Subject ${id}`;
//                   return (
//                     <option key={id} value={id}>
//                       {label}
//                     </option>
//                   );
//                 })}
//               </select>
//             </div>
//           </>
//         )}
//       </div>
//       <div className="d-flex justify-content-end gap-2 mt-4">
//         <button
//           className="btn btn-secondary"
//           type="button"
//           onClick={handleClose}
//         >
//           Close
//         </button>

//         {!isView && (
//           <button
//             className="btn btn-primary"
//             type="button"
//             onClick={handleSave}
//             disabled={saving}
//           >
//             {saving ? "Saving..." : "Save"}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }

export default function EditOrViewLawCollegeQuiz({
  quizType,
  questionType,
  onSuccess,
}) {
  const dispatch = useDispatch();
  const { questionForm = {}, mode } = useSelector((s) => s.schoolQuiz || {});
  const [saving, setSaving] = useState(false);

  //for themse and groups
  const {
    themes,
    themesStatus,
    themesError,
    groups,
    groupsStatus,
    groupsError,
    subjectsList,
    subjectsBasedClasses,
  } = useSelector((state) => state.schoolQuiz);
  const { updateQuizForm, selectedSubThemes } = useSelector(
    (state) => state.quizManagement,
  );
  // const { classes = [], subjects = [] } = useSelector(
  //   (state) => state.chapter || {}
  // );

  // Load both themes and groups on mount
  useEffect(() => {
    if (quizType === 3 || quizType === 4) {
      dispatch(fetchThemes());

      dispatch(fetchGroups());
    }
  }, [dispatch, quizType]);
  useEffect(() => {
    if (groups?.data?.length && questionForm.group_id) {
      updateField("group_id", String(questionForm.group_id));
      // const match = groups.data.find(
      //   (g) => String(g.group_id) === String(questionForm.group_id)
      // );
      // if (match) {
      // }
    }
  }, [groups, questionForm.group_id]);
  // user id parsing
  const userStr = localStorage.getItem("user");
  const userId = userStr ? JSON.parse(userStr)?.id || "" : "";

  // helper to update a single field inside questionForm in redux
  const updateField = (key, value) => {
    dispatch(setQuestionForm({ key, value }));
  };
  console.log("questionForm", questionForm);
  console.log("groupis", questionForm.group_id);

  // convenience values (fallbacks)
  const qId = questionForm.questionId ?? questionForm.id ?? "";
  const questionText = questionForm.question ?? questionForm.content ?? "";
  const option_a = questionForm.option_a ?? questionForm.options?.A ?? "";
  const option_b = questionForm.option_b ?? questionForm.options?.B ?? "";
  const option_c = questionForm.option_c ?? questionForm.options?.C ?? "";
  const option_d = questionForm.option_d ?? questionForm.options?.D ?? "";
  const correct_option = questionForm.correct_option ?? "";
  const difficulty_level =
    questionForm.difficulty_level ?? questionForm.level ?? "";
  const selectedTheme = selectedSubThemes
    ? selectedSubThemes
    : [updateQuizForm.themeId];
  // questionForm.theme_id ?? questionForm.theme ?? questionForm.themeId ?? "";

  const selectedGroup = questionForm.group_id
    ? String(
        questionForm.group_id,
        // ?? questionForm.group ?? questionForm.groupId ?? ""
      )
    : "";
  console.log("groupis new", selectedGroup);

  const selectedClass = questionForm.class_id ?? "";
  const selectedSubject = questionForm.subject_id ?? "";
  const hasTheme = selectedTheme !== "";
  const hasGroup = selectedGroup !== "";
  const hasThemeAndGroup = hasTheme && hasGroup;

  const isView = mode === "view";

  const handleChange = (key, value) => {
    dispatch({
      type: "schoolQuiz/setState",
      payload: { key, value },
    });
  };

  // Fetch classes once on mount (unconditional)
  useEffect(() => {
    dispatch(fetchSubjects());
  }, [dispatch]);

  // Fetch subjects whenever the selectedClass inside questionForm changes
  // useEffect(() => {
  //   if (!selectedSubject) return;
  //   console.log("selectedSubject", selectedSubject);
  //   dispatch(
  //     fetchSubjectBasedClassesData({ subject_id: String(selectedSubject) })
  //   );
  // }, [dispatch, selectedSubject]);

  const handleSave = async () => {
    if (!questionText.trim()) {
      alert("Question text is required.");
      return;
    }

    if (!option_a || !option_b || !option_c || !option_d) {
      alert("All options are required.");
      return;
    }

    if (!correct_option) {
      alert("Correct option is required.");
      return;
    }

    if (!difficulty_level) {
      alert("Difficulty is required.");
      return;
    }

    setSaving(true);

    try {
      if (!qId) return;

      const payload = {
        id: qId,
        content: questionText,
        level: difficulty_level,
        correct_option,
        updated_by: userId || null,
        options: {
          A: option_a,
          B: option_b,
          C: option_c,
          D: option_d,
        },
      };

      if (hasThemeAndGroup) {
        payload.theme_id = selectedTheme;
        payload.group_id = selectedGroup;

        await dispatch(updateThematicQuestion(payload)).unwrap();
      } else {
        payload.class_id = selectedClass;
        payload.subject_id = selectedSubject;

        await dispatch(updateQuestion(payload)).unwrap();
      }

      alert("Question updated successfully.");

      // Close popup
      dispatch(setState({ key: "openPopUp", value: false }));
      dispatch(setState({ key: "mode", value: "" }));

      // Refresh only table data
      if (onSuccess) {
        await onSuccess();
      }
    } catch (err) {
      console.error("Save error:", err);

      const errMsg =
        err?.message ||
        err?.response?.data?.message ||
        err?.response?.data ||
        "Question update failed.";

      alert(errMsg);
    } finally {
      setSaving(false);
    }
  };

  const handleUpload = async () => {
    if (!questionText.trim()) {
      alert("Question text is required.");
      return;
    }

    if (!option_a || !option_b || !option_c || !option_d) {
      alert("All options are required.");
      return;
    }

    if (!correct_option) {
      alert("Correct option is required.");
      return;
    }

    if (!difficulty_level) {
      alert("Difficulty is required.");
      return;
    }

    setSaving(true);

    try {
      if (qId) {
        const payload = {
          id: qId,
          question: questionText,
          level: difficulty_level,
          correct_option,
          created_by: userId || null, // use updated_by for update
          option_A: option_a,
          option_B: option_b,
          option_C: option_c,
          option_D: option_d,
          quizType,
        };

        let successMessage = "";

        if (hasThemeAndGroup) {
          payload.theme_id = selectedTheme;
          payload.group_id = selectedGroup;

          await dispatch(updateSkippedThematicQuestion(payload)).unwrap();

          successMessage = "Thematic question updated successfully.";
        } else {
          payload.class_id = selectedClass;
          payload.subject_id = selectedSubject;

          await dispatch(updateSkippedQuestion(payload)).unwrap();

          successMessage = "Academic question updated successfully.";
        }

        alert(successMessage);

        dispatch(setState({ key: "openPopUp", value: false }));
        dispatch(setState({ key: "mode", value: "" }));

        if (hasThemeAndGroup) {
          dispatch(getThematicQuizQuestions({ body: {} }));
        } else {
          dispatch(getQuizQuestions({ body: {} }));
        }

        window.location.reload();
      }
    } catch (err) {
      console.error("Save error:", err);

      const errMsg =
        err?.message ||
        err?.response?.data?.message ||
        err?.response?.data ||
        "Question update failed.";

      alert(errMsg);
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    dispatch(setState({ key: "openPopUp", value: false }));
    dispatch(setState({ key: "mode", value: "" }));
  };

  // const selectedSubThemes = questionForm.theme_id;
  useEffect(() => {
    if (selectedSubject) {
      dispatch(
        fetchSubjectBasedClassesData({ subject_id: String(selectedSubject) }),
      );
    }
  }, [dispatch, selectedSubject]);
  const subjects = subjectsList?.data || [];
  const classes = questionForm.subjectSpecificClasses?.data || [];

  return (
    <div>
      <div className="mb-4">
        <label className="form-label font-medium">Question</label>
        <textarea
          className="form-control"
          value={questionText}
          onChange={(e) => updateField("question", e.target.value)}
          readOnly={isView}
          rows={3}
        />
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Option A</label>
          <input
            className="form-control"
            value={option_a}
            onChange={(e) => updateField("option_a", e.target.value)}
            readOnly={isView}
          />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Option B</label>
          <input
            className="form-control"
            value={option_b}
            onChange={(e) => updateField("option_b", e.target.value)}
            readOnly={isView}
          />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Option C</label>
          <input
            className="form-control"
            value={option_c}
            onChange={(e) => updateField("option_c", e.target.value)}
            readOnly={isView}
          />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Option D</label>
          <input
            className="form-control"
            value={option_d}
            onChange={(e) => updateField("option_d", e.target.value)}
            readOnly={isView}
          />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Correct Option</label>
          <select
            className="form-control"
            value={correct_option}
            onChange={(e) => updateField("correct_option", e.target.value)}
            disabled={isView}
          >
            <option value="">-- Select --</option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="D">D</option>
          </select>
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">Difficulty</label>
          <select
            className="form-control"
            value={difficulty_level}
            onChange={(e) => updateField("difficulty_level", e.target.value)}
            disabled={isView}
          >
            <option value="">-- Select --</option>
            <option value="basic">Basic</option>
            <option value="advanced">Advanced</option>
            <option value="ultra">Ultra</option>
            <option value="docmaster">Docmaster</option>
          </select>
        </div>
      </div>
      {/* {quizType === "thematic" && ( */}
      {(quizType === 3 || quizType === 4) && (
        <ThemeSelector
          themes={themes}
          themeData={questionForm.themeData}
          isView={isView}
        />
      )}{" "}
      {/* )} */}
      {/* CONDITIONAL: show Theme+Group if question object contains them, otherwise show Class+Subject */}
      <div className="mt-3">
        {hasThemeAndGroup ? (
          <>
            <div className="mb-3">
              <label className="form-label">Group</label>
              {
                <select
                  className="form-control"
                  name="group_id"
                  value={selectedGroup}
                  onChange={(e) => {
                    handleChange("group_id", e.target.value);
                    updateField("group_id", e.target.value);
                  }}
                  disabled={isView}
                >
                  <option value="">-- Select Group --</option>
                  {groups?.data?.map((g) => (
                    <option key={g.group_id} value={String(g.group_id)}>
                      {g.group_name}
                    </option>
                  ))}
                </select>
              }
            </div>
          </>
        ) : (
          <>
            {/* Subject */}
            <div className="mb-3">
              <label className="form-label">Subject</label>

              <select
                className="form-control"
                value={selectedSubject || ""}
                onChange={(e) => {
                  const newSubjectId = e.target.value;
                  updateField("subject_id", newSubjectId);
                  dispatch(
                    fetchSubjectBasedClassesData({ subject_id: newSubjectId }),
                  );
                }}
                disabled={isView}
              >
                <option value="">-- Select Subject --</option>
                {subjects?.map((s) => {
                  const id = String(s.subject_id ?? s.id ?? s._id ?? "");
                  const label = s.subject_name ?? s.name ?? `Subject ${id}`;
                  return (
                    <option key={id} value={id}>
                      {label}
                    </option>
                  );
                })}
              </select>
            </div>
            {/* Class */}
            <div className="mb-3">
              <label className="form-label">Class</label>

              <select
                className="form-control"
                value={selectedClass || ""}
                onChange={(e) => {
                  const newClassId = e.target.value; // always primitive (string)

                  updateField("class_id", newClassId);
                  // updateField("subject_id", "");
                }}
                disabled={isView}
              >
                <option value="">-- Select Class --</option>
                {classes?.map((c) => {
                  const id = c.class_id ?? c.id ?? c._id ?? "";
                  const label = c.class_name ?? c.name ?? `Class ${id}`;
                  return (
                    <option key={id} value={id}>
                      {label}
                    </option>
                  );
                })}
              </select>
            </div>
          </>
        )}
      </div>
      <div className="d-flex justify-content-end gap-2 mt-4">
        <button
          className="btn btn-secondary"
          type="button"
          onClick={handleClose}
        >
          Close
        </button>
        {/* {qu estionType} */}
        {!isView && questionType === "uploaded" && (
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save"}
          </button>
        )}
        {!isView && questionType === "skipped" && (
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleUpload}
            disabled={saving}
          >
            {saving ? "Uploading..." : "Upload"}
          </button>
        )}
      </div>
    </div>
  );
}
